import apolloClient from '@/store/apollo';

import CreateContactGql from '@/store/graphql/mutations/CreateContact.gql';

export default {
    createContact: contact =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateContactGql,
                    variables: {
                        contact
                    }
                })
                .then(({ data }) => resolve(data.Contact))
                .catch(error => reject(error.message));
        })
};
